/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EdgeInitdOnboardingConfig } from '../models';
// @ts-ignore
import type { EdgeLocation } from '../models';
// @ts-ignore
import type { EdgeLocationUpdate } from '../models';
// @ts-ignore
import type { ListEdgeLocationsResponse } from '../models';
// @ts-ignore
import type { OffboardEdgeLocationResponse } from '../models';
// @ts-ignore
import type { OnboardEdgeInitdResponse } from '../models';
// @ts-ignore
import type { OnboardEdgeLocationResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * EdgeLocationsAPIApi - axios parameter creator
 * @export
 */
export const EdgeLocationsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Method to create edge location.
         * @summary Create edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {EdgeLocation} edgeLocation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPICreateEdgeLocation: async (organizationId: string, clusterId: string, edgeLocation: EdgeLocation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPICreateEdgeLocation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPICreateEdgeLocation', 'clusterId', clusterId)
            // verify required parameter 'edgeLocation' is not null or undefined
            assertParamExists('edgeLocationsAPICreateEdgeLocation', 'edgeLocation', edgeLocation)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(edgeLocation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to delete edge location.
         * @summary Delete edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIDeleteEdgeLocation: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIDeleteEdgeLocation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIDeleteEdgeLocation', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIDeleteEdgeLocation', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to generate the edge initd script.
         * @summary Get edge agent init script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the edge location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIGetEdgeInitdScript: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIGetEdgeInitdScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIGetEdgeInitdScript', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIGetEdgeInitdScript', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}:edgeInitdScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to get edge location details.
         * @summary Get edge location details
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIGetEdgeLocation: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIGetEdgeLocation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIGetEdgeLocation', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIGetEdgeLocation', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to list edge locations.
         * @summary List edge locations
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIListEdgeLocations: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIListEdgeLocations', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIListEdgeLocations', 'clusterId', clusterId)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to offboard edge location credentials.
         * @summary Offboard edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge-location to be offboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOffboardEdgeLocation: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIOffboardEdgeLocation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIOffboardEdgeLocation', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIOffboardEdgeLocation', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}:offboard`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to return the script to offboard the edge location.
         * @summary Get offboarding script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOffboardEdgeLocationScript: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIOffboardEdgeLocationScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIOffboardEdgeLocationScript', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIOffboardEdgeLocationScript', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}:offboardScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to onboard edge initd agent.
         * @summary Onboard edge initd agent
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge-location to be onboarded.
         * @param {EdgeInitdOnboardingConfig} edgeInitdOnboardingConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOnboardEdgeInitd: async (organizationId: string, clusterId: string, id: string, edgeInitdOnboardingConfig: EdgeInitdOnboardingConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeInitd', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeInitd', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeInitd', 'id', id)
            // verify required parameter 'edgeInitdOnboardingConfig' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeInitd', 'edgeInitdOnboardingConfig', edgeInitdOnboardingConfig)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}:onboardEdgeInitd`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(edgeInitdOnboardingConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to onboard edge location credentials.
         * @summary Onboard edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge-location to be onboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOnboardEdgeLocation: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeLocation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeLocation', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeLocation', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}:onboard`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to return the script to onboard the cluster.
         * @summary Get onboarding script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location to be onboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOnboardEdgeLocationScript: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeLocationScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeLocationScript', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIOnboardEdgeLocationScript', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}:onboardScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to update edge location with credentials and networking resources.
         * @summary Update edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location to be updated.
         * @param {EdgeLocationUpdate} edgeLocationUpdate 
         * @param {string} [updateMask] The list of fields to be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIUpdateEdgeLocation: async (organizationId: string, clusterId: string, id: string, edgeLocationUpdate: EdgeLocationUpdate, updateMask?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeLocationsAPIUpdateEdgeLocation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeLocationsAPIUpdateEdgeLocation', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeLocationsAPIUpdateEdgeLocation', 'id', id)
            // verify required parameter 'edgeLocationUpdate' is not null or undefined
            assertParamExists('edgeLocationsAPIUpdateEdgeLocation', 'edgeLocationUpdate', edgeLocationUpdate)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updateMask !== undefined) {
                localVarQueryParameter['updateMask'] = updateMask;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(edgeLocationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EdgeLocationsAPIApi - functional programming interface
 * @export
 */
export const EdgeLocationsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EdgeLocationsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Method to create edge location.
         * @summary Create edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {EdgeLocation} edgeLocation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPICreateEdgeLocation(organizationId: string, clusterId: string, edgeLocation: EdgeLocation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EdgeLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPICreateEdgeLocation(organizationId, clusterId, edgeLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPICreateEdgeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to delete edge location.
         * @summary Delete edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIDeleteEdgeLocation(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIDeleteEdgeLocation(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIDeleteEdgeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to generate the edge initd script.
         * @summary Get edge agent init script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the edge location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIGetEdgeInitdScript(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIGetEdgeInitdScript(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIGetEdgeInitdScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to get edge location details.
         * @summary Get edge location details
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIGetEdgeLocation(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EdgeLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIGetEdgeLocation(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIGetEdgeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to list edge locations.
         * @summary List edge locations
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIListEdgeLocations(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEdgeLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIListEdgeLocations(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIListEdgeLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to offboard edge location credentials.
         * @summary Offboard edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge-location to be offboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIOffboardEdgeLocation(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffboardEdgeLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIOffboardEdgeLocation(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIOffboardEdgeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to return the script to offboard the edge location.
         * @summary Get offboarding script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIOffboardEdgeLocationScript(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIOffboardEdgeLocationScript(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIOffboardEdgeLocationScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to onboard edge initd agent.
         * @summary Onboard edge initd agent
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge-location to be onboarded.
         * @param {EdgeInitdOnboardingConfig} edgeInitdOnboardingConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIOnboardEdgeInitd(organizationId: string, clusterId: string, id: string, edgeInitdOnboardingConfig: EdgeInitdOnboardingConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardEdgeInitdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIOnboardEdgeInitd(organizationId, clusterId, id, edgeInitdOnboardingConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIOnboardEdgeInitd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to onboard edge location credentials.
         * @summary Onboard edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge-location to be onboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIOnboardEdgeLocation(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardEdgeLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIOnboardEdgeLocation(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIOnboardEdgeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to return the script to onboard the cluster.
         * @summary Get onboarding script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location to be onboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIOnboardEdgeLocationScript(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIOnboardEdgeLocationScript(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIOnboardEdgeLocationScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to update edge location with credentials and networking resources.
         * @summary Update edge location
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} id The ID of the edge location to be updated.
         * @param {EdgeLocationUpdate} edgeLocationUpdate 
         * @param {string} [updateMask] The list of fields to be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeLocationsAPIUpdateEdgeLocation(organizationId: string, clusterId: string, id: string, edgeLocationUpdate: EdgeLocationUpdate, updateMask?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EdgeLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeLocationsAPIUpdateEdgeLocation(organizationId, clusterId, id, edgeLocationUpdate, updateMask, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeLocationsAPIApi.edgeLocationsAPIUpdateEdgeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EdgeLocationsAPIApi - factory interface
 * @export
 */
export const EdgeLocationsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EdgeLocationsAPIApiFp(configuration)
    return {
        /**
         * Method to create edge location.
         * @summary Create edge location
         * @param {EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPICreateEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EdgeLocation> {
            return localVarFp.edgeLocationsAPICreateEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to delete edge location.
         * @summary Delete edge location
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIDeleteEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.edgeLocationsAPIDeleteEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to generate the edge initd script.
         * @summary Get edge agent init script
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIGetEdgeInitdScript(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.edgeLocationsAPIGetEdgeInitdScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to get edge location details.
         * @summary Get edge location details
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIGetEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EdgeLocation> {
            return localVarFp.edgeLocationsAPIGetEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to list edge locations.
         * @summary List edge locations
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIListEdgeLocations(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListEdgeLocationsResponse> {
            return localVarFp.edgeLocationsAPIListEdgeLocations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to offboard edge location credentials.
         * @summary Offboard edge location
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOffboardEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OffboardEdgeLocationResponse> {
            return localVarFp.edgeLocationsAPIOffboardEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to return the script to offboard the edge location.
         * @summary Get offboarding script
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOffboardEdgeLocationScript(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.edgeLocationsAPIOffboardEdgeLocationScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to onboard edge initd agent.
         * @summary Onboard edge initd agent
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOnboardEdgeInitd(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitdRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardEdgeInitdResponse> {
            return localVarFp.edgeLocationsAPIOnboardEdgeInitd(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.edgeInitdOnboardingConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to onboard edge location credentials.
         * @summary Onboard edge location
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOnboardEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardEdgeLocationResponse> {
            return localVarFp.edgeLocationsAPIOnboardEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to return the script to onboard the cluster.
         * @summary Get onboarding script
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIOnboardEdgeLocationScript(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.edgeLocationsAPIOnboardEdgeLocationScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to update edge location with credentials and networking resources.
         * @summary Update edge location
         * @param {EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeLocationsAPIUpdateEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EdgeLocation> {
            return localVarFp.edgeLocationsAPIUpdateEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.edgeLocationUpdate, requestParameters.updateMask, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for edgeLocationsAPICreateEdgeLocation operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocationRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocation
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocation
     */
    readonly clusterId: string

    /**
     * 
     * @type {EdgeLocation}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocation
     */
    readonly edgeLocation: EdgeLocation
}

/**
 * Request parameters for edgeLocationsAPIDeleteEdgeLocation operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocationRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocation
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocation
     */
    readonly clusterId: string

    /**
     * The ID of the edge location to be deleted.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocation
     */
    readonly id: string
}

/**
 * Request parameters for edgeLocationsAPIGetEdgeInitdScript operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScriptRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScript
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScript
     */
    readonly clusterId: string

    /**
     * The ID of the edge location.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScript
     */
    readonly id: string
}

/**
 * Request parameters for edgeLocationsAPIGetEdgeLocation operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocationRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocation
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocation
     */
    readonly clusterId: string

    /**
     * The ID of the edge location.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocation
     */
    readonly id: string
}

/**
 * Request parameters for edgeLocationsAPIListEdgeLocations operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocationsRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocationsRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocations
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocations
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocations
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for edgeLocationsAPIOffboardEdgeLocation operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocation
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocation
     */
    readonly clusterId: string

    /**
     * The ID of the edge-location to be offboarded.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocation
     */
    readonly id: string
}

/**
 * Request parameters for edgeLocationsAPIOffboardEdgeLocationScript operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScriptRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScript
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScript
     */
    readonly clusterId: string

    /**
     * The ID of the edge location to be deleted.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScript
     */
    readonly id: string
}

/**
 * Request parameters for edgeLocationsAPIOnboardEdgeInitd operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitdRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitdRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitd
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitd
     */
    readonly clusterId: string

    /**
     * The ID of the edge-location to be onboarded.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitd
     */
    readonly id: string

    /**
     * 
     * @type {EdgeInitdOnboardingConfig}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitd
     */
    readonly edgeInitdOnboardingConfig: EdgeInitdOnboardingConfig
}

/**
 * Request parameters for edgeLocationsAPIOnboardEdgeLocation operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocation
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocation
     */
    readonly clusterId: string

    /**
     * The ID of the edge-location to be onboarded.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocation
     */
    readonly id: string
}

/**
 * Request parameters for edgeLocationsAPIOnboardEdgeLocationScript operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScriptRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScript
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScript
     */
    readonly clusterId: string

    /**
     * The ID of the edge location to be onboarded.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScript
     */
    readonly id: string
}

/**
 * Request parameters for edgeLocationsAPIUpdateEdgeLocation operation in EdgeLocationsAPIApi.
 * @export
 * @interface EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocationRequest
 */
export interface EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocation
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocation
     */
    readonly clusterId: string

    /**
     * The ID of the edge location to be updated.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocation
     */
    readonly id: string

    /**
     * 
     * @type {EdgeLocationUpdate}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocation
     */
    readonly edgeLocationUpdate: EdgeLocationUpdate

    /**
     * The list of fields to be updated.
     * @type {string}
     * @memberof EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocation
     */
    readonly updateMask?: string
}

/**
 * EdgeLocationsAPIApi - object-oriented interface
 * @export
 * @class EdgeLocationsAPIApi
 * @extends {BaseAPI}
 */
export class EdgeLocationsAPIApi extends BaseAPI {
    /**
     * Method to create edge location.
     * @summary Create edge location
     * @param {EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPICreateEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPICreateEdgeLocationRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPICreateEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to delete edge location.
     * @summary Delete edge location
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIDeleteEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIDeleteEdgeLocationRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIDeleteEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to generate the edge initd script.
     * @summary Get edge agent init script
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIGetEdgeInitdScript(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeInitdScriptRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIGetEdgeInitdScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to get edge location details.
     * @summary Get edge location details
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIGetEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIGetEdgeLocationRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIGetEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to list edge locations.
     * @summary List edge locations
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIListEdgeLocations(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIListEdgeLocationsRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIListEdgeLocations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to offboard edge location credentials.
     * @summary Offboard edge location
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIOffboardEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIOffboardEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to return the script to offboard the edge location.
     * @summary Get offboarding script
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIOffboardEdgeLocationScript(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOffboardEdgeLocationScriptRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIOffboardEdgeLocationScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to onboard edge initd agent.
     * @summary Onboard edge initd agent
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIOnboardEdgeInitd(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeInitdRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIOnboardEdgeInitd(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.edgeInitdOnboardingConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to onboard edge location credentials.
     * @summary Onboard edge location
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIOnboardEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIOnboardEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to return the script to onboard the cluster.
     * @summary Get onboarding script
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIOnboardEdgeLocationScript(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIOnboardEdgeLocationScriptRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIOnboardEdgeLocationScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to update edge location with credentials and networking resources.
     * @summary Update edge location
     * @param {EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeLocationsAPIApi
     */
    public edgeLocationsAPIUpdateEdgeLocation(requestParameters: EdgeLocationsAPIApiEdgeLocationsAPIUpdateEdgeLocationRequest, options?: RawAxiosRequestConfig) {
        return EdgeLocationsAPIApiFp(this.configuration).edgeLocationsAPIUpdateEdgeLocation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.edgeLocationUpdate, requestParameters.updateMask, options).then((request) => request(this.axios, this.basePath));
    }
}

